module.exports = __webpack_public_path__ + "assets/img/11.17d17f43.gif";